<div class="comparative-analysis-page">
  <div class="top-action-section">
    <div class="filter-container">
      <div class="filter">
        <app-single-select-dropdown
          label="Chart type"
          [items]="chartTypeDropdownOptions"
          width="126px"
          [selectedItem]="selectedChartType"
          (callback)="onChartTypeChange($event)"
        >
        </app-single-select-dropdown>
      </div>
      <div class="filter">
        <app-comparative-chart-ticker-filter
          [recentlyVisitedCompanies]="recentlyVisitedCompanies"
          [tickerSelectionType]="tickerSelectionType"
          [tickers]="tickers"
          [customTickers]="customTickers"
          [tickerIncludeAverageSelected]="tickerIncludeAverageSelected"
          [watchlistData]="watchlistData"
          [industryMenuData]="industryMenuData"
          [marketGeoData]="marketGeoData"
          [suggestedPeers]="suggestedPeers"
          [headerTitle]=""
          [pageType]="pageType"
          [compId]="compId"
          [selectedChartType]="selectedChartType"
          (updateTickersFromEditModalStatus)="updateTickers($event)"
          (updateTickerSelectionTypeStatus)="
            handleTickerSelectionTypeChange($event)
          "
        ></app-comparative-chart-ticker-filter>
        <!-- [updateChartState]="handleChartState()" -->
        <!-- [initiateWatchlistFetch]="handleInitiateWatchlistFetch()" -->
        <!-- [updateUnsavedDataStatus]="" -->
      </div>
      <div class="filter chart-filter">
        <app-lineitem-filter
          [options]="lineItemsData"
          [selectedValue]="{}"
          [selectedOptionsId]="getSelectedLineIdsFoBinding()"
          liFilterId="caChartLI"
          [bottomBorderView]="true"
          [disabled]="
            isMetaInProgress ||
            isStdLineItemsUpdateInProgress ||
            isUserSettingUpdateInProgress
          "
          placeholder="&nbsp;Add Line Item"
          label="Line Items"
          [showButton]="true"
          (onValueChange)="handleLineItemSelection($event)"
          (onEditButtonClick)="handleEditLineItems()"
        ></app-lineitem-filter>
      </div>
      <div class="filter industry-currency-filter">
        <va-currency-select
          size="small"
          selectWidth="78"
          labelPlacement="top"
          [bottomBorderView]="true"
          [selectedCurrency]="currency"
          [suggestedCurrencies]="currencyOptionList"
          [apiEP]="apiEP"
          apiUrl="/api/get_available_currencies"
          (onChange)="updateCurrency($event)"
        >
        </va-currency-select>
      </div>
      <div class="filter">
        <va-period-filter
          [filterWidthVariation]="getPeriodFilterWidth()"
          [periodData]="getPeriodDataForBinding()"
          [dataAvailable]="periodsWithAvailableData"
          [periodMinMax]="periodMinMax"
          (onApply)="handlePeriodApply($event)"
        ></va-period-filter>
      </div>
      <div class="filter" *ngIf="showFilter(true, true, false)">
        <app-single-select-dropdown
          *ngIf="trendComparisonViewBy !== null"
          (callback)="onDataViewChange($event)"
          [label]="'Values or YoY%'"
          [items]="dataViewList"
          width="100px"
          [selectedItem]="trendComparisonViewBy"
        >
        </app-single-select-dropdown>
      </div>
      <div class="filter" *ngIf="showFilter(false, false, true)">
        <app-revision-period-select
          [selectedRevision]="revisionValueOfRevisionChart"
          (onChange)="onRevisionChange($event)"
          [createChart]="'false'"
        ></app-revision-period-select>
      </div>
      <div class="filter index-alignment">
        <label
          nz-checkbox
          [(ngModel)]="isIndexToHundreadSelected"
          (ngModelChange)="handleIndexCheckboxChange($event)"
          [nzDisabled]="isMetaInProgress || isUserSettingUpdateInProgress"
          >Index Chart to 100</label
        >
      </div>
    </div>
  </div>
  <section
    id="comprativeChartSection"
    class="comparative-chart-content-section mt-12"
  >
    <div *ngIf="!isMetaInProgress" class="multi-charts-conainer">
      <div *ngFor="let item of getDisplayList(); index as i" class="chart-sect">
        <app-chart-content
          [currentItem]="item"
          [currentIndex]="i"
          [chartOptions]="getChartOptionsForBinding()"
          [chartType]="selectedChartType"
          [viewportOptions]="viewportOptions"
          [periodLabel]="getPeriodLabel()"
          (isDownloadingInProgress)="updateDownloadStatus($event)"
        ></app-chart-content>
      </div>
    </div>

    <div *ngIf="!isMetaInProgress" class="marketdata_copyright_footnote">
      {{ marketDataCopyRightMessage }}
    </div>
  </section>
  <div class="snack-bar-overlay" *ngIf="overlayOn"></div>

  <!-- Snackbar -->
  <ng-template #successTemplate>
    <div class="snackbar-content">
      <va-icon
        isFontAwesome="true"
        [name]="faCheck"
        class="snack-icon snack-success-icon"
      ></va-icon
      ><span>{{ snackbarMessage }}</span>
      <span class="snack-cross-icon" (click)="dismissSnackBar()">
        <va-icon isFontAwesome="true" [name]="faTimes"></va-icon>
      </span>
    </div>
  </ng-template>
  <ng-template #failureTemplate>
    <div class="snackbar-content">
      <va-icon
        isFontAwesome="true"
        [name]="faTimesCircle"
        class="snack-icon snack-failure-icon"
      ></va-icon
      ><span>{{ snackbarMessage }}</span>
      <span class="snack-cross-icon" (click)="dismissSnackBar()">
        <va-icon isFontAwesome="true" [name]="faTimes"></va-icon>
      </span>
    </div>
  </ng-template>
  <ng-template #infoTemplate>
    <div class="snackbar-content">
      <va-icon
        isFontAwesome="true"
        [name]="faInfoCircle"
        class="snack-icon snack-info-icon"
      ></va-icon
      ><span>{{ snackbarMessage }}</span>
      <span class="snack-cross-icon" (click)="dismissSnackBar()">
        <va-icon isFontAwesome="true" [name]="faTimes"></va-icon>
      </span>
    </div>
  </ng-template>
  <ng-template #warningTemplate>
    <div class="snackbar-content warning-snack-bar">
      <va-icon
        size="small"
        name="exclamation-triangle"
        class="snack-icon snack-warning-icon"
      ></va-icon>
      <span class="snackbar-message">{{ snackbarMessage }}</span>
      <button
        nz-button
        class="snackbar-edit-btn"
        (click)="handleEditLineItems()"
      >
        Edit line items
      </button>
      <span class="snack-cross-icon" (click)="dismissSnackBar()">
        <va-icon isFontAwesome="true" [name]="faTimes"></va-icon>
      </span>
    </div>
  </ng-template>
</div>
